import { Modal, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ClientPlan } from "../../../types";

import { Button } from "../../index";

import useStyles from "./styles";
import CustomInput from "../../CustomInput";
import { useGetSubscriptionPlanConsumption } from "../../../api/plans/hooks";

export interface CheckOutPlanProps {
  open: boolean;
  client: ClientPlan[];
  onClose: () => void;
  handleSave: (id: string) => void;
}

export const CheckOutPlan: React.FC<CheckOutPlanProps> = ({
  open,
  client,
  onClose,
  handleSave,
}) => {
  const Styles = useStyles();

  const { data: subscriptionPlanConsumption } =
    useGetSubscriptionPlanConsumption();

  const [clientsList, setClientsList] = useState<ClientPlan[]>([]);
  const [filterName, setFilterName] = useState<string>("");

  const filterClientsByName = (c: any) => {
    if (!filterName) return true;
    const formattedFilterName = filterName.toLowerCase().replace(/\s+/g, "");
    const formattedClientName = c.name.toLowerCase().replace(/\s+/g, "");
    return formattedClientName.includes(formattedFilterName);
  };

  const loadClients = async () => {
    if (clientsList) {
      const filteredPlans = clientsList.filter((c: any) =>
        filterClientsByName(c),);

      setClientsList(filteredPlans);
    }
  };

  const verifyEnrollment = (enrollment: string) => {
    if (!enrollment) return null;
    return (
      <Typography component="span" className={Styles.ownerEnrollment} noWrap>
        {enrollment}
      </Typography>
    );
  };

  const verifyFoodRestriction = (foodRestriction: string) => {
    if (!foodRestriction) return null;
    return (
      <Typography component="span" className={Styles.ownerEnrollment}>
        {foodRestriction}
      </Typography>
    );
  };

  const verifyCanceledSubscription = (
    status?: number | string,
    nextTimeToCharge?: string,
  ) => {
    if (Number(status) !== 3 || !nextTimeToCharge) return null;

    const dateOnly = nextTimeToCharge.split("T")[0];
    const [year, month, day] = dateOnly.split("-");
    if (!year || !month || !day) return null;
    const formattedDate = `${day}/${month}/${year}`;

    return (
      <Typography
        component="span"
        className={Styles.ownerEnrollment}
        style={{ color: "#D32F2F" }}
      >
        Assinatura cancelada vigente até:
        {' '}
        {formattedDate}
      </Typography>
    );
  };

  const hasConsumptionToday = (subscriptionId: string) => {
    console.log(subscriptionId);
    if (!subscriptionPlanConsumption) return false;

    const today = new Date().toISOString().split("T")[0];

    return subscriptionPlanConsumption.some((item: any) => {
      const consumed = item.consumedAt.split("T")[0];
      return (
        consumed === today && item?.subscriptionPlanId?.id === subscriptionId
      );
    });
  };

  const handleClose = () => {
    onClose();

    setClientsList([]);
  };

  useEffect(() => {
    if (client.length > 0 && !filterName) {
      setClientsList(client);
    }
  }, [client, filterName]);

  useEffect(() => {
    (async () => {
      if (filterName) {
        await loadClients();
      }
    })();
  }, [filterName]);

  return (
    <Modal className={Styles.modal} open={open} onClose={onClose}>
      <div className={Styles.modalView}>
        <div className={Styles.filterWrapper}>
          <CustomInput
            label="Buscar por nome"
            value={filterName}
            onChange={(e) => setFilterName(e.target.value)}
          />
        </div>
        <hr className={Styles.line} />
        <div className={Styles.items}>
          {clientsList.map((c) => (
            <div key={c.id} className={Styles.item}>
              <div className={Styles.collunName}>
                <Typography
                  component="span"
                  className={Styles.ownerName}
                  noWrap
                >
                  {c.name}
                </Typography>
                {verifyEnrollment(c.identityNumber)}
                {verifyFoodRestriction(c.foodRestriction || "")}
                {verifyCanceledSubscription(c.status, c.nextTimeToCharge)}
              </div>

              {!hasConsumptionToday(c.subscriptionId) && (
                <Button
                  color="primary"
                  size="small"
                  onClick={() => handleSave(c.subscriptionId)}
                >
                  CheckOut
                </Button>
              )}
            </div>
          ))}
        </div>

        <div className={Styles.footer}>
          <div className={Styles.actions}>
            <Button
              color="secondary"
              fullWidth
              size="large"
              onClick={handleClose}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
